import { VALID_INVOICES_OPTIONS } from '../../../constants/validInvoices';

export const getStatusLabel = (status) =>
	VALID_INVOICES_OPTIONS.find((option) => option.value === status)?.label ||
	'----';
